import {Observable} from 'rxjs';
import {Parameter} from '../common/parameter';
import { Binary } from '@angular/compiler';
import { Timestamp } from 'rxjs/internal/operators/timestamp';

export interface ShiftMstParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface ShiftMst {
    id?: number;
    shiftDisplayTime:string;
     shiftStartTime:any;
     shiftEndTime:any;
    branchId: any;
    tenantId :any;
    name:string;
    
    parameters?: ShiftMstParameter[];
    links?: any;
}

export abstract class ShiftMstData {
   
    abstract list(url: string): Observable<ShiftMst[]>;
    abstract create(url: string, data: ShiftMst): Observable<ShiftMst[]>;
    abstract update(url: string, data: ShiftMst): Observable<any>;
    abstract delete(url: string): Observable<any>;
}